// North American VIN check digit (position 9): transliterate, weight, sum mod 11, 10 = 'X'.
const LETTERS = 'ABCDEFGHJKLMNPRSTUVWXYZ'
const VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9]
const WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2]

// The expected check character, or null when the VIN is not 17 valid characters (no I, O or Q).
export function vinCheckDigit(vin) {
  const v = String(vin || '').trim().toUpperCase()
  if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(v)) return null
  let sum = 0
  for (let i = 0; i < 17; i++) {
    const c = v[i]
    sum += (c >= '0' && c <= '9' ? Number(c) : VALUES[LETTERS.indexOf(c)]) * WEIGHTS[i]
  }
  const r = sum % 11
  return r === 10 ? 'X' : String(r)
}
